var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: {
        color: _vm.getColor,
        outlined: "",
        centered: "",
        timeout: "3000"
      },
      model: {
        value: _vm.snackbar,
        callback: function($$v) {
          _vm.snackbar = $$v
        },
        expression: "snackbar"
      }
    },
    [
      _c(
        "v-avatar",
        {
          staticStyle: { "margin-right": "10px" },
          attrs: { size: "24", color: _vm.getColor }
        },
        [
          _c("v-icon", {
            class: _vm.iconName,
            attrs: { size: "14", color: "#fff !important" }
          })
        ],
        1
      ),
      _vm._v("\n  " + _vm._s(_vm.snackbarMsg) + "\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }